import * as CONSTANTS from '@/store/constants.js'

const AppConstants = {
    install (Vue, options) {
        Vue.prototype.$c = (key) => {
            return CONSTANTS[key]
        }
    }
}
  
  export default AppConstants
